import { NrlkAPI } from './api';

export class NrlkClient {
  constructor(entreprise, token = null) {
    this.api = new NrlkAPI(entreprise, token);
  }

  setEntreprise(entreprise) { this.api.setEntreprise(entreprise); }
  setToken(token) { this.api.setToken(token); }

  async getClient() {
    return this.api.get('/extranet/client');
  }
}
